const tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let players = [];

function onYouTubeIframeAPIReady() {
    const videos = document.querySelectorAll('.video');

    videos.forEach(video => {
        const playButton = video.querySelector('.play-button');
        const videoPreview = video.querySelector('.video-preview');
        const videoIframe = video.querySelector('.video-iframe');

        videoPreview.addEventListener('click', () => {
            videoPreview.remove();
            playButton.remove();
            videoIframe.style.display = 'block';

            player = new YT.Player(videoIframe.id, {
                videoId: videoIframe.getAttribute('data-youtube-video-id'),
                events: {
                    'onReady': play,
                }
            });

            players.push(player);
        });
    });
}

function play(event) {
    event.target.playVideo();
}

function stopAll() {
    players.forEach(player => {
        player.stopVideo();
    });
    players = [];
}
